import { Typography, Button } from "@material-tailwind/react";
import HorizontalSeparator from '../components/Utils/HorizontalSeparator.js';
import ImgSaone from '../images/Saone.png';
import ImgLavande from '../images/Lavande.jpg';
import ImgPhare from '../images/Phare.jpg';
import ImgColline from '../images/Colline.jpg';

function ContactForm() {
  return (
	<div className="w-full">
		<Typography variant="h3" color="blue-gray" className="mb-8 mt-28">Mes prochaines tournées</Typography>
		<div className="flex w-full md:w-4/6 items-center mx-auto mt-5">
			<div className="md:columns-2 w-full h-auto">
				<img alt="nature" className="md:h-[50vh] w-auto" src={ImgSaone}/>
				<div className="flex items-center md:h-[50vh]">
					<div className="gap-2 w-full md:text-left md:pl-20">
						<Typography variant="h4" color="blue-gray" className="mb-2"><a className="hover:text-black" href="/ContactForm">Région Lyonnaise et Isère Rhodanien</a></Typography>
						<Typography variant="h5" color="blue-gray">Disponibilités toute l’année</Typography>
					</div>
				</div>
			</div>
		</div>
		<HorizontalSeparator/>
		<div className="w-4/6 mx-auto md:flex mx-1 md:columns-3 mt-5 gap-2 text-justify">
			<div className="md:w-2/6 items-center">
				<div className="w-full mx-auto">
					<img alt="nature" className="min-h-[20vh] max-h-[50vh] w-auto" src={ImgLavande}/>
					<div className="gap-2 w-full text-justify">
						<Typography variant="h5" color="blue-gray" className="mb-2"><a className="hover:text-black" href="/ContactForm">Drôme &amp; Ardèche</a></Typography>
						<Typography variant="paragraph" color="blue-gray">Du 17 au 19 février 2025</Typography>
						<Typography variant="paragraph" color="blue-gray">Du 21 au 23 avril 2025</Typography>
					</div>
				</div>
			</div>
			<div className="md:w-2/6 items-center mt-5 md:mt-0">
				<div className="w-full mx-auto">
					<img alt="nature" className="min-h-[20vh] max-h-[50vh] w-auto" src={ImgPhare}/>
					<div className="gap-2 w-full text-justify">
						<Typography variant="h5" color="blue-gray" className="mb-2"><a className="hover:text-black" href="/ContactForm">Côtes d’Armor &amp; Ille-et-Villaine</a></Typography>
						<Typography variant="paragraph" color="blue-gray">Du 24 au 26 février 2025</Typography>
					</div>
				</div>
			</div>
			<div className="md:w-2/6 items-center mt-5 md:mt-0">
				<div className="w-full mx-auto">
					<img alt="nature" className="min-h-[20vh] max-h-[50vh] w-auto" src={ImgColline}/>
					<div className="gap-2 w-full text-justify">
						<Typography variant="h5" color="blue-gray" className="mb-2"><a className="hover:text-black" href="/ContactForm">Loire &amp; Haute-Loire</a></Typography>
						<Typography variant="paragraph" color="blue-gray">Du 14 au 16 avril 2025</Typography>
					</div>
				</div>
			</div>
		</div>
		<HorizontalSeparator/>
		<div className="">
			<p className="mb-2" >Votre région n’est pas citée ? J’étudierai votre demande et reviendrai vers vous au plus vite :</p>
			<a href="/ContactForm"><Button className="text-sm">Demander des renseignements</Button></a>
		</div>
	</div>
  );
}

export default ContactForm;
